<template>
  <div id="adminItemTechnicalSpecification">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ technicalSpecification }}</router-link>
      </li>
      <li class="breadcrumb-menu">
        <a v-if="spanRowSelected" class="btn" href="#" :title="info">
          <i class="fa fa-info-circle"></i>
        </a>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div
            class="tab-pane nopadding active"
            id="tabAdminItemTechnicalSpecification"
            role="tabpanel"
          >
            <div class="card-body card-body-table">
              <div class="tab-content">
                <div class="tab-pane active" id="tabItemBody" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-12">
                      <bootstrapTable
                        :configurations="tableConfiguration"
                        :datas="tableData"
                        id="tableAdminItemTechnicalSpecification"
                        ref="tableAdminItemTechnicalSpecification"
                        :results="tableResult"
                        singleSelect="true"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="tabTechnicalSpecificationBody" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-12 text-right">
                      <span v-if="spanRowSelected != ''">
                        {{ item }}:
                        <b>{{ spanRowSelected }}</b>
                      </span>
                    </div>
                  </div>
                  <div class="row">&nbsp;</div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-sm-2">
                          <span style="vertical-align:sub;">{{ language }}</span>
                        </div>
                        <div class="col-sm-4">
                          <span style="vertical-align:sub;">{{ defaultLanguageDescription }}</span>
                        </div>
                        <div class="col-sm-3 text-right">
                          <span style="vertical-align:sub;">{{ version }}</span>
                        </div>
                        <div class="col-sm-3">
                          <select2
                            class="form-control"
                            id="sHistoryDefaultLanguage"
                            :default="historyDefaultLanguageDefault"
                            name="sHistoryDefaultLanguage"
                            :options="historyDefaultLanguageData"
                            :change="historyDefaultLanguageChange"
                            ref="sHistoryDefaultLanguage"
                          />
                        </div>
                      </div>
                      <div class="row">&nbsp;</div>
                      <div class="row">
                        <tabDetail
                          functions="adminItemTechnicalSpecificationDefaultLanguage"
                          :configurations="
                            technicalSpecificationDefaultLanguageConfiguration
                          "
                          :jsonValue="technicalSpecificationDefaultLanguageData"
                        ></tabDetail>
                      </div>
                      <div class="row" v-if="enableManagement">&nbsp;</div>
                      <div class="row" v-if="enableManagement">
                        <div class="col-lg-3">
                          <label for="complete">{{complete}}</label>
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin:2px; vertical-align:bottom;"
                          >
                            <input
                              type="checkbox"
                              class="switch-input"
                              id="completed"
                              name="completed"
                              v-model="rowSelected.completeTechnicalSpecification"
                              @change="completeTechnicalsSpecifications()"
                            />
                            <span class="switch-slider" data-on data-off></span>
                          </label>
                        </div>
                        <div class="col-lg-9 text-right">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="cancelNewTechnicalsSpecifications"
                          >
                            <i class="fa fa-times"></i>
                            <span>{{ cancel }}</span>
                          </button>
                          <button
                            type="button"
                            class="btn btn-success"
                            :disabled="disableHystoryDefaultLanguageSaveButton"
                            @click="
                              saveNewTechnicalsSpecificationsDefaultLanguage
                            "
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>{{ save }}</span>
                          </button>
                          <button
                            type="button"
                            class="btn btn-warning"
                            @click="duplicateNewTechnicalsSpecifications"
                            :disabled="disableDuplicateButton"
                          >
                            <i class="fa fa-clone"></i>
                            <span>{{ duplicate }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- OTHER LANGUAGE -->
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-sm-2">
                          <span style="vertical-align:sub;">{{ language }}</span>
                        </div>
                        <div class="col-sm-4">
                          <select2
                            class="form-control"
                            id="sLanguageHistory"
                            :default="historyLanguageDefault"
                            name="sLanguageHistory"
                            :change="historyLanguageChange"
                            service="languages"
                          />
                        </div>
                        <div class="col-sm-3 text-right">
                          <span style="vertical-align:sub;">{{ version }}</span>
                        </div>
                        <div class="col-sm-3">
                          <select2
                            class="form-control"
                            id="sHistory"
                            :default="historyDefault"
                            name="sHistory"
                            :options="historyData"
                            :change="historyChange"
                            ref="sHistory"
                          />
                        </div>
                      </div>
                      <div class="row">&nbsp;</div>
                      <div class="row">
                        <tabDetail
                          functions="adminItemTechnicalSpecification"
                          :configurations="technicalSpecificationConfiguration"
                          :jsonValue="technicalSpecificationData"
                        ></tabDetail>
                      </div>
                      <div class="row" v-if="enableManagement">&nbsp;</div>
                      <div class="row" v-if="enableManagement">
                        <div class="col-lg-12 text-right">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="cancelNewTechnicalsSpecifications"
                          >
                            <i class="fa fa-times"></i>
                            <span>{{ cancel }}</span>
                          </button>
                          <button
                            type="button"
                            class="btn btn-success"
                            :disabled="disableHystorySaveButton"
                            @click="saveNewTechnicalsSpecifications"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>{{ save }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import TabDetail from "@/components/TabDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminItemTechnicalSpecification",
  components: {
    BootstrapTable,
    TabDetail,
    Select2
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      complete: dictionaryHelpers.getDictionary("Complete"),
      defaultLanguageDescription: storageData.sDescriptionLanguage(),
      disableTab: true,
      disableHystoryDefaultLanguageSaveButton: false,
      disableHystorySaveButton: false,
      disableDuplicateButton: true,
      duplicate: dictionaryHelpers.getDictionary("Duplicate"),
      enableManagement: false,
      historyData: [],
      historyDefaultLanguageData: [],
      historyDefault: "",
      historyDefaultLanguageDefault: "",
      historyLanguageDefault: {},
      info: dictionaryHelpers.getDictionary("InfoTechnicalSpecification"),
      item: dictionaryHelpers.getDictionary("Item"),
      items: dictionaryHelpers.getDictionary("Items"),
      language: dictionaryHelpers.getDictionary("Language"),
      noRowSelected: dictionaryHelpers.getDictionary("NoRowSelected"),
      moreRowSelected: dictionaryHelpers.getDictionary("MoreRowSelected"),
      rowSelected: {},
      save: dictionaryHelpers.getDictionary("Save"),
      sHistoryDefaultLanguageId: "sHistoryDefaultLanguage",
      sHistoryId: "sHistory",
      sLanguageHistoryId: "sLanguageHistory",
      spanRowSelected: "",
      tabItemBodyId: "tabItemBody",
      tableConfiguration: [],
      tableData: [],
      tableResult: [],
      tabTechnicalSpecificationBodyId: "tabTechnicalSpecificationBody",
      technicalSpecification: dictionaryHelpers.getDictionary(
        "TechnicalSpecification"
      ),
      technicalSpecificationConfiguration: [],
      technicalSpecificationData: {},
      technicalSpecificationDefaultLanguageConfiguration: [],
      technicalSpecificationDefaultLanguageData: {},
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      version: dictionaryHelpers.getDictionary("Version"),
      url: window.location.pathname
    };
  },
  created() {
    var adminItemTechnicalSpecification = this;

    adminConfigurationServices.getFunctionality(function(result) {
      adminItemTechnicalSpecification.loadItem();
      adminItemTechnicalSpecification.tableConfiguration =
        result.data.tablesConfigurations;
      $.each(result.data.tabsConfigurations[0].pageConfigurations, function(
        i,
        config
      ) {
        if (config.label == "canManage" && config.defaultValue == 1) {
          adminItemTechnicalSpecification.enableManagement = true;
        }
      });
    });
  },
  methods: {
    /***   ITEM   ***/

    loadItem() {
      var adminItemTechnicalSpecification = this;
      this.rowSelected = {};

      itemServices.getWithGroupTechnicalSpecification(function(result) {
        adminItemTechnicalSpecification.tableData = result.data;
      });
    },
    onItemTab() {
      this.spanRowSelected = "";
    },
    onDetail() {
      spinnerHelpers.show();
      this.onTechnicalSpecificationTab();
      $("#" + this.tabItemBodyId).removeClass("active");
      $("#" + this.tabTechnicalSpecificationBodyId).addClass("active");
    },

    /***   END ITEM   ***/

    /***   TECHNICAL SPECIFICATION   ***/

    onTechnicalSpecificationTab() {
      var adminItemTechnicalSpecification = this;

      this.historyDefaultLanguageDefault = "";
      this.historyDefaultLanguageData = [];
      itemTechnicalSpecificationServices.getVersion(
        this.rowSelected.id,
        storageData.sIdLanguage(),
        function(result) {
          if (functionHelpers.isValued(result.data) && result.data.length > 0) {
            adminItemTechnicalSpecification.historyDefaultLanguageData =
              result.data;
          }
          adminItemTechnicalSpecification.historyDefaultLanguageDefault =
            "Last";
        }
      );

      this.spanRowSelected =
        this.rowSelected.internalCodeItem +
        " - " +
        this.rowSelected.descriptionItem;
      this.historyDefault = "";
      this.historyData = [];
      itemTechnicalSpecificationServices.getVersion(
        this.rowSelected.id,
        null,
        function(result) {
          if (functionHelpers.isValued(result.data) && result.data.length > 0) {
            adminItemTechnicalSpecification.historyData = result.data;
          }
          adminItemTechnicalSpecification.historyDefault = "Last";
          adminItemTechnicalSpecification.historyLanguageDefault = {
            id: storageData.sIdLanguage(),
            text: storageData.sDescriptionLanguage()
          };
        }
      );
    },
    cancelNewTechnicalsSpecifications() {
      spinnerHelpers.show();
      this.loadItem();
      this.spanRowSelected = "";
      $("#" + this.tabItemBodyId).addClass("active");
      $("#" + this.tabTechnicalSpecificationBodyId).removeClass("active");
      spinnerHelpers.hide();
    },
    saveNewTechnicalsSpecificationsDefaultLanguage() {
      spinnerHelpers.show();
      var adminItemTechnicalSpecification = this;
      var dataToSave = this.technicalSpecificationDefaultLanguageData;

      dataToSave.idItem = this.rowSelected.id;
      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      dataToSave.idLanguage = storageData.sIdLanguage();

      itemTechnicalSpecificationServices.insert(dataToSave, function() {
        adminItemTechnicalSpecification.loadItem();
        $("#" + adminItemTechnicalSpecification.tabItemBodyId).addClass(
          "active"
        );
        $(
          "#" + adminItemTechnicalSpecification.tabTechnicalSpecificationBodyId
        ).removeClass("active");
        notificationHelpers.success(
          adminItemTechnicalSpecification.updateCompleted
        );
        spinnerHelpers.hide();
      });
    },
    saveNewTechnicalsSpecifications() {
      spinnerHelpers.show();
      var adminItemTechnicalSpecification = this;
      var dataToSave = this.technicalSpecificationData;
      var idLanguage = $("#" + this.sLanguageHistoryId).val();

      dataToSave.idItem = this.rowSelected.id;
      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      dataToSave.idLanguage = Number(idLanguage);

      itemTechnicalSpecificationServices.insert(dataToSave, function() {
        adminItemTechnicalSpecification.loadItem();
        $("#" + adminItemTechnicalSpecification.tabItemBodyId).addClass(
          "active"
        );
        $(
          "#" + adminItemTechnicalSpecification.tabTechnicalSpecificationBodyId
        ).removeClass("active");
        notificationHelpers.success(
          adminItemTechnicalSpecification.updateCompleted
        );
        spinnerHelpers.hide();
      });
    },
    historyDefaultLanguageChange(value) {
      spinnerHelpers.show();
      var adminItemTechnicalSpecification = this;

      this.technicalSpecificationDefaultLanguageConfiguration = [];

      if (!functionHelpers.isValued(value) || value == "Last") {
        this.disableHystoryDefaultLanguageSaveButton = false;

        itemTechnicalSpecificationServices.getConfiguration(
          this.rowSelected.id,
          storageData.sIdLanguage(),
          function(result) {
            adminItemTechnicalSpecification.loadHistoryDefaultLanguageData(
              value
            );

            if (
              functionHelpers.isValued(result.data) &&
              functionHelpers.isValued(result.data.tabsConfigurations) &&
              result.data.tabsConfigurations.length > 0
            ) {
              if (!adminItemTechnicalSpecification.enableManagement) {
                $.each(
                  result.data.tabsConfigurations[0].pageConfigurations,
                  function(i, config) {
                    config.isDisabled = true;
                  }
                );
              }

              adminItemTechnicalSpecification.technicalSpecificationDefaultLanguageConfiguration =
                result.data.tabsConfigurations;
            }
          }
        );
      } else {
        this.disableHystoryDefaultLanguageSaveButton = true;

        itemTechnicalSpecificationServices.getVersionConfiguration(
          this.rowSelected.id,
          value,
          storageData.sIdLanguage(),
          function(result) {
            adminItemTechnicalSpecification.loadHistoryDefaultLanguageData(
              value
            );
            if (
              functionHelpers.isValued(result.data) &&
              functionHelpers.isValued(result.data.tabsConfigurations) &&
              result.data.tabsConfigurations.length > 0
            ) {
              if (!adminItemTechnicalSpecification.enableManagement) {
                $.each(
                  result.data.tabsConfigurations[0].pageConfigurations,
                  function(i, config) {
                    config.isDisabled = true;
                  }
                );
              }

              adminItemTechnicalSpecification.technicalSpecificationDefaultLanguageConfiguration =
                result.data.tabsConfigurations;
            }
          }
        );
      }

      if (
        $("#" + this.sLanguageHistoryId).val() != storageData.sIdLanguage() &&
        value == "Last"
      ) {
        this.disableDuplicateButton = false;
      } else {
        this.disableDuplicateButton = true;
      }
    },
    historyChange(value) {
      spinnerHelpers.show();
      var adminItemTechnicalSpecification = this;
      var idLanguage = $("#" + this.sLanguageHistoryId).val();

      this.technicalSpecificationConfiguration = [];

      if (!functionHelpers.isValued(value) || value == "Last") {
        this.disableHystorySaveButton = false;

        itemTechnicalSpecificationServices.getConfiguration(
          this.rowSelected.id,
          idLanguage,
          function(result) {
            adminItemTechnicalSpecification.loadHistoryData(value);

            if (
              functionHelpers.isValued(result.data) &&
              functionHelpers.isValued(result.data.tabsConfigurations) &&
              result.data.tabsConfigurations.length > 0
            ) {
              if (!adminItemTechnicalSpecification.enableManagement) {
                $.each(
                  result.data.tabsConfigurations[0].pageConfigurations,
                  function(i, config) {
                    config.isDisabled = true;
                  }
                );
              }

              adminItemTechnicalSpecification.technicalSpecificationConfiguration =
                result.data.tabsConfigurations;
            }
          }
        );
      } else {
        this.disableHystorySaveButton = true;

        itemTechnicalSpecificationServices.getVersionConfiguration(
          this.rowSelected.id,
          value,
          idLanguage,
          function(result) {
            adminItemTechnicalSpecification.loadHistoryData(value);
            if (
              functionHelpers.isValued(result.data) &&
              functionHelpers.isValued(result.data.tabsConfigurations) &&
              result.data.tabsConfigurations.length > 0
            ) {
              if (!adminItemTechnicalSpecification.enableManagement) {
                $.each(
                  result.data.tabsConfigurations[0].pageConfigurations,
                  function(i, config) {
                    config.isDisabled = true;
                  }
                );
              }

              adminItemTechnicalSpecification.technicalSpecificationConfiguration =
                result.data.tabsConfigurations;
            }
          }
        );
      }
    },
    loadHistoryDefaultLanguageData(value) {
      var adminItemTechnicalSpecification = this;
      this.technicalSpecificationDefaultLanguageData = {};

      itemTechnicalSpecificationServices.get(
        this.rowSelected.id,
        storageData.sIdLanguage(),
        value,
        function(result) {
          if (
            functionHelpers.isValued(result) &&
            functionHelpers.isValued(result.data) &&
            result.data.length != 0
          ) {
            adminItemTechnicalSpecification.technicalSpecificationDefaultLanguageData =
              result.data;
          }
          spinnerHelpers.hide();
        }
      );
    },
    loadHistoryData(value) {
      var adminItemTechnicalSpecification = this;
      this.technicalSpecificationData = {};
      var idLanguage = $("#" + this.sLanguageHistoryId).val();

      itemTechnicalSpecificationServices.get(
        this.rowSelected.id,
        idLanguage,
        value,
        function(result) {
          if (
            functionHelpers.isValued(result) &&
            functionHelpers.isValued(result.data) &&
            result.data.length != 0
          ) {
            adminItemTechnicalSpecification.technicalSpecificationData =
              result.data;
          }
          spinnerHelpers.hide();
        }
      );
    },
    historyLanguageChange(value) {
      var adminItemTechnicalSpecification = this;
      this.technicalSpecificationConfiguration = [];

      if (
        value != storageData.sIdLanguage() &&
        $("#" + this.sHistoryDefaultLanguageId).val() == "Last"
      ) {
        this.disableDuplicateButton = false;
      } else {
        this.disableDuplicateButton = true;
      }

      itemTechnicalSpecificationServices.getVersion(
        this.rowSelected.id,
        value,
        function(result) {
          if (functionHelpers.isValued(result.data) && result.data.length > 0) {
            adminItemTechnicalSpecification.historyData = result.data;
          }
          adminItemTechnicalSpecification.historyDefault = "Last";
        }
      );

      itemTechnicalSpecificationServices.getConfiguration(
        this.rowSelected.id,
        value,
        function(result) {
          if (
            functionHelpers.isValued(result.data) &&
            functionHelpers.isValued(result.data.tabsConfigurations) &&
            result.data.tabsConfigurations.length > 0
          ) {
            if (!adminItemTechnicalSpecification.enableManagement) {
              $.each(
                result.data.tabsConfigurations[0].pageConfigurations,
                function(i, config) {
                  config.isDisabled = true;
                }
              );
            }

            adminItemTechnicalSpecification.technicalSpecificationConfiguration =
              result.data.tabsConfigurations;
          }
        }
      );

      this.loadHistoryData($("#" + this.sHistoryId).val());
    },

    technicalSpecificationFormatter(value, row, index, field) {
      var adminItemTechnicalSpecification = this;

      var jsonRow =
        "JSON.parse('" +
        functionHelpers.replaceAll(
          functionHelpers.replaceAll(
            functionHelpers.replaceAll(
              functionHelpers.replaceAll(
                functionHelpers.replaceAll(
                  functionHelpers.replaceAll(
                    functionHelpers.replaceAll(
                      functionHelpers.replaceAll(
                        JSON.stringify(row),
                        "'",
                        "\\'"
                      ),
                      '"',
                      "'"
                    ),
                    "{'",
                    "{&quot;"
                  ),
                  "'}",
                  "&quot;}"
                ),
                "',",
                "&quot;,"
              ),
              ",'",
              ",&quot;"
            ),
            "':",
            "&quot;:"
          ),
          ":'",
          ":&quot;"
        ) +
        "')";

      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<div class="col-1"><button class="btn btn-success" onclick="adminItemTechnicalSpecification.__vue__.rowSelected = ' +
        jsonRow +
        '; adminItemTechnicalSpecification.__vue__.onDetail();"><i class="fa fa-pencil" title="' +
        dictionaryHelpers.getDictionary("OpenDetail") +
        '"></i></button></div>';

      if (
        functionHelpers.isValued(row.completeTechnicalSpecification) &&
        row.completeTechnicalSpecification
      ) {
        html +=
          '<div class="col"><i class="fa fa-check-square-o text-primary" title="' +
          this.complete +
          '"></i></div>';
      }

      if (functionHelpers.isValued(adminItemTechnicalSpecification.results)) {
        $.each(adminItemTechnicalSpecification.results, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminItemTechnicalSpecification.updateCompleted;
              }
              html += '"></i></div>';
            } else {
              html +=
                '<div class="col"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '"></i></div>';
            }
            return;
          }
        });
      }

      html += "</div></div>";
      return html;
    },

    duplicateNewTechnicalsSpecifications() {
      var adminItemTechnicalSpecification = this;
      spinnerHelpers.show();

      itemTechnicalSpecificationServices.get(
        this.rowSelected.id,
        null,
        null,
        function(result) {
          if (
            functionHelpers.isValued(result) &&
            functionHelpers.isValued(result.data) &&
            result.data.length != 0
          ) {
            adminItemTechnicalSpecification.technicalSpecificationData =
              result.data;
          }
          spinnerHelpers.hide();
        }
      );
    },

    completeTechnicalsSpecifications() {
      var adminItemTechnicalSpecification = this;
      spinnerHelpers.show();
      itemTechnicalSpecificationServices.complete(
        this.rowSelected.id,
        this.rowSelected.completeTechnicalSpecification,
        function(result) {
          adminItemTechnicalSpecification.loadItem();
          $("#" + adminItemTechnicalSpecification.tabItemBodyId).addClass(
            "active"
          );
          $(
            "#" +
              adminItemTechnicalSpecification.tabTechnicalSpecificationBodyId
          ).removeClass("active");
          notificationHelpers.success(
            adminItemTechnicalSpecification.updateCompleted
          );
          spinnerHelpers.hide();
        }
      );
    }

    /***   END TECHNICAL SPECIFICATION   ***/
  }
};
</script>
